import React, { useEffect, useRef } from "react";
import { QRCodeSVG, QRCodeCanvas } from "qrcode.react";
import { Printer, Download } from "lucide-react";
import { applySeo } from "../lib/seo";

const TARGET = "https://gadgetguymedia.com/audit?src=print-qr";
const NAVY = "#0B1E3A";

export default function AuditQrPage() {
  const canvasWrap = useRef(null);

  useEffect(
    () =>
      applySeo({
        path: "/audit/qr",
        title: "Free Local AI Audit QR — Gadget Guy Media",
        description: "Printable QR code for the Free Local AI Audit.",
        robots: "noindex, nofollow",
      }),
    []
  );

  const download = () => {
    const canvas = canvasWrap.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = "gadgetguymedia-audit-qr.png";
    a.click();
  };

  return (
    <div className="min-h-screen py-10 px-5 flex flex-col items-center gap-8 audit-qr-root" style={{ background: "var(--ggm-navy)" }} data-testid="audit-qr-page">
      <style>{`@media print { .no-print { display:none !important } .audit-qr-root { background:#fff !important; padding:0 !important } @page { size: 5in 7in; margin: 0 } }`}</style>

      <div className="no-print flex flex-wrap gap-3">
        <button type="button" onClick={() => window.print()} className="ggm-btn-primary" data-testid="audit-qr-print-btn">
          Print card <Printer size={16} />
        </button>
        <button type="button" onClick={download} className="ggm-btn-secondary" data-testid="audit-qr-download-btn">
          Download QR (PNG) <Download size={16} />
        </button>
      </div>

      <div
        className="bg-white text-center flex flex-col items-center justify-between"
        style={{ width: "5in", height: "7in", padding: "0.45in 0.4in", color: NAVY, borderTop: "10px solid #28C8F0" }}
        data-testid="audit-qr-card"
      >
        <div className="w-full rounded-lg flex justify-center py-3" style={{ background: NAVY, WebkitPrintColorAdjust: "exact", printColorAdjust: "exact" }}>
          <img src="/brand-v2/logos/horizontal-with-tagline.png" alt="Gadget Guy Media" style={{ height: 72 }} />
        </div>
        <div>
          <div className="font-condensed uppercase tracking-[0.24em] text-xs" style={{ color: "#0B3CDC" }}>
            Free · Gallatin · Sumner County
          </div>
          <h1 className="font-condensed uppercase leading-[0.95] mt-2" style={{ fontSize: 44 }} data-testid="audit-qr-headline">
            Free Local<br />AI Audit
          </h1>
          <p className="font-body text-sm mt-3 leading-snug">
            Find out where your business is losing customers online. Plain-English report in 3 business days.
          </p>
        </div>
        <QRCodeSVG value={TARGET} size={190} fgColor={NAVY} level="M" marginSize={0} data-testid="audit-qr-svg" />
        <div>
          <div className="font-condensed uppercase text-xs tracking-widest">Scan or visit</div>
          <div className="font-condensed text-xl font-bold" data-testid="audit-qr-url">gadgetguymedia.com/audit</div>
        </div>
      </div>

      <div ref={canvasWrap} className="hidden">
        <QRCodeCanvas value={TARGET} size={1200} fgColor={NAVY} level="M" marginSize={4} />
      </div>
      <p className="no-print font-body text-white/50 text-xs">Scans are tracked as “Audit Print-QR Scans” on /robert/stats.</p>
    </div>
  );
}
